<dxp-checkbox [checked]="this.params.value" [disabled]="!this.params.isEditable" (checkboxData)="this.setCheckState($event)"></dxp-checkbox>